export const LOADING_NOTIFICATIONS = '/account/notifications/loading_notifications';
export const LOADING_NOTIFICATIONS_SUCCESS = '/account/notifications/loading_notifications_success';
export const LOADING_NOTIFICATIONS_ERROR = '/account/notifications/loading_notifications_error';
export const SAVE_NOTIFICATIONS = '/account/notifications/save_notifications';
export const TOGGLE_SEEN_STATE = '/account/toggle_seen_state';
export const SHOW_POPUP = '/account/showpopup';
